function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var WithdrawalsTemplate = require('./withdrawals.template');
var WithdrawalOverlay = require('./overlays/withdrawal');
var _require = require('../web3-amount'),
  decimalIsPositive = _require.decimalIsPositive;
var _require2 = require('./overlays/listing-field-edit'),
  returnStoreWeb3Tickers = _require2.returnStoreWeb3Tickers,
  requestStoreWeb3Tickers = _require2.requestStoreWeb3Tickers;
var WithdrawalsView = /*#__PURE__*/function () {
  function WithdrawalsView(app, mod) {
    var _this = this;
    var container = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    _classCallCheck(this, WithdrawalsView);
    this.app = app;
    this.mod = mod;
    this.container = container;
    this.overlay = new WithdrawalOverlay(app, mod);
    this.balances = {};
    this.app.connection.on('saito-purchase-cryptos', function () {
      if (!_this.isVisible()) {
        return;
      }
      _this.render(_this.container, {
        requestTickers: false
      });
    });
  }
  return _createClass(WithdrawalsView, [{
    key: "isVisible",
    value: function isVisible() {
      if (!this.container) {
        return false;
      }
      var panel = document.querySelector(this.container);
      return !!(panel !== null && panel !== void 0 && panel.classList.contains('is-active'));
    }
  }, {
    key: "returnRows",
    value: function returnRows() {
      var _this2 = this;
      return returnStoreWeb3Tickers(this.app).filter(function (ticker) {
        return ticker !== 'SAITO';
      }).map(function (ticker) {
        var balance = _this2.balances[ticker] || {};
        return {
          ticker: ticker,
          eligible: balance.eligible || 0,
          pending: balance.pending || 0
        };
      });
    }
  }, {
    key: "applyBalances",
    value: function applyBalances() {
      var response = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var pending = response !== null && response !== void 0 && response.pending && _typeof(response.pending) === 'object' ? response.pending : {};
      var eligible = response !== null && response !== void 0 && response.eligible && _typeof(response.eligible) === 'object' ? response.eligible : {};
      var balances = {};
      for (var _i = 0, _Object$entries = Object.entries(_objectSpread(_objectSpread({}, pending), eligible)); _i < _Object$entries.length; _i++) {
        var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          ticker = _Object$entries$_i[0],
          amount = _Object$entries$_i[1];
        var symbol = String(ticker || '').trim().toUpperCase();
        if (!symbol || symbol === 'SAITO') {
          continue;
        }
        if (!balances[symbol]) {
          balances[symbol] = {
            pending: 0,
            eligible: 0
          };
        }
      }
      for (var _i2 = 0, _Object$entries2 = Object.entries(pending); _i2 < _Object$entries2.length; _i2++) {
        var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
          _ticker = _Object$entries2$_i[0],
          _amount = _Object$entries2$_i[1];
        var _symbol = String(_ticker || '').trim().toUpperCase();
        if (!balances[_symbol]) {
          continue;
        }
        balances[_symbol].pending = _amount;
      }
      for (var _i3 = 0, _Object$entries3 = Object.entries(eligible); _i3 < _Object$entries3.length; _i3++) {
        var _Object$entries3$_i = _slicedToArray(_Object$entries3[_i3], 2),
          _ticker2 = _Object$entries3$_i[0],
          _amount2 = _Object$entries3$_i[1];
        var _symbol2 = String(_ticker2 || '').trim().toUpperCase();
        if (!balances[_symbol2]) {
          continue;
        }
        balances[_symbol2].eligible = _amount2;
      }
      this.balances = balances;
    }
  }, {
    key: "loadBalances",
    value: function loadBalances() {
      var _this$app,
        _this3 = this;
      var peerKey = this.mod.store_public_key;
      if (!peerKey || !((_this$app = this.app) !== null && _this$app !== void 0 && (_this$app = _this$app.network) !== null && _this$app !== void 0 && _this$app.sendRequestAsTransaction)) {
        this.balances = {};
        return Promise.resolve();
      }
      return new Promise(function (resolve) {
        _this3.app.network.sendRequestAsTransaction('load-web3-proceeds', {
          module: 'Store'
        }, function (response) {
          _this3.applyBalances(response || {});
          resolve();
        }, peerKey);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (container) {
        this.container = container;
      }
      if (!this.container) {
        return;
      }
      if (options.requestTickers !== false) {
        requestStoreWeb3Tickers(this.app);
      }
      this.app.browser.replaceElementContentBySelector(WithdrawalsTemplate({
        rows: this.returnRows()
      }), this.container);
      this.attachEvents();
    }
  }, {
    key: "show",
    value: function () {
      var _show = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return this.loadBalances();
            case 1:
              this.render();
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function show() {
        return _show.apply(this, arguments);
      }
      return show;
    }()
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this4 = this;
      var root = document.querySelector(this.container);
      if (!root) {
        return;
      }
      root.querySelectorAll('[data-action="withdraw"]').forEach(function (link) {
        link.addEventListener('click', /*#__PURE__*/function () {
          var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(e) {
            var ticker, row;
            return _regenerator().w(function (_context2) {
              while (1) switch (_context2.n) {
                case 0:
                  e.preventDefault();
                  ticker = link.getAttribute('data-ticker') || '';
                  _context2.n = 1;
                  return _this4.loadBalances();
                case 1:
                  _this4.render(_this4.container, {
                    requestTickers: false
                  });
                  row = _this4.returnRows().find(function (item) {
                    return item.ticker === ticker;
                  });
                  if (!(!row || !decimalIsPositive(row.eligible))) {
                    _context2.n = 2;
                    break;
                  }
                  return _context2.a(2);
                case 2:
                  _this4.overlay.open(ticker);
                case 3:
                  return _context2.a(2);
              }
            }, _callee2);
          }));
          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }());
      });
    }
  }]);
}();
module.exports = WithdrawalsView;